/**
 * Per-tab guidance copy + which tabs are document-bearing vs structured-form.
 *
 * Keeping this in one place so swapping the industry preset later is trivial.
 */
export const VAULT_TAB_META = {
  identity: {
    type: 'documents',
    guidance: 'Upload your current government-issued photo ID (passport, UK driving licence, or national ID), plus a proof-of-address document dated within the last 3 months (utility bill, bank statement, or council tax letter).',
    accept: '.pdf,.png,.jpg,.jpeg,.heic,.webp',
    empty: 'No identity documents yet. Upload at least one photo ID + one proof of address.',
  },
  rtw: {
    type: 'documents',
    guidance: 'For UK candidates: upload your Home Office share code (PDF). For non-UK candidates: visa, BRP, or work permit. Documents are checked against the Home Office Right to Work code of practice.',
    empty: 'No Right-to-Work documents yet.',
  },
  employment_history: {
    type: 'documents',
    guidance: 'Last 5 years (10 for SMCR senior roles): employer reference letters, P60s, payslips, or signed reference templates. Gap explanations may be attached as PDFs.',
    empty: 'No employment-history documents yet.',
  },
  qualifications: {
    type: 'documents',
    guidance: 'Degree certificates, professional qualifications (CFA, ICA, ACCA), regulatory licences. Originals or notarised copies preferred.',
    empty: 'No qualification documents yet.',
  },
  background_checks: {
    type: 'documents',
    guidance: 'DBS basic/standard/enhanced certificate, CIFAS clearance, credit check report, sanctions screening result. All consent-gated; we will only request what your target role requires.',
    empty: 'No background-check documents yet.',
  },
  smcr: {
    type: 'documents',
    guidance: 'Structured regulatory references from each FCA/PRA-authorised firm you worked for in the last 6 years. Use the Joint Reference Template (Form A or Form B as applicable).',
    empty: 'No regulatory references yet.',
  },
  conduct: {
    type: 'documents',
    guidance: 'Declarations of outside business interests, family conflicts, political exposure, and any breaches of FCA Conduct Rules (COCON).',
    empty: 'No conduct declarations yet.',
  },
  acknowledgements: {
    type: 'documents',
    guidance: 'Signed copies of the firm\'s Code of Conduct, Anti-Bribery & Corruption policy, Market Abuse policy, and Whistleblowing policy. Click below to view the latest versions before signing.',
    empty: 'No signed acknowledgements yet.',
  },
  health_fitness: {
    type: 'documents',
    guidance: 'Only required for roles flagged as physically demanding or safety-critical. Upload the occupational-health attestation from your assessor.',
    empty: 'No health & fitness documents required.',
  },
  audit_trail: {
    type: 'system',
    guidance: 'Every access to your vault — by you, by recruiters, by background-check partners — is logged here. You can download a full UK GDPR Article 15 data-subject access report below.',
  },
};
